export default __webpack_public_path__ + "static/media/edit.7f61dda1.svg";